var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"editing-toggle icon",class:{active: _vm.draggingCategories},on:{"click":_vm.toggleDraggingCategories}},[_c('v-icon',{attrs:{"name":"list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }